import React from "react";
import { useMemo } from "react";
import CancelBooking from "./tripModals/CancelBooking";
import CarrentDetail from "./tripModals/CarrentDetail";

import HotelDetail from "./tripModals/HotelDetail";
import TransferDetail from "./tripModals/TransferDetail";
import { useDispatch } from "react-redux";
import FlightDetail from "./tripModals/FlightDetail";

const DetailModal = ({
  show,
  setShow,
  detailType,
  modalData,
  checkRef,
  deleting,
  setDeleting,
  setModalData,
  change,
  setChange,
  setTripType,
}) => {
  const dispatch = useDispatch();
  const { Authorization } =
    JSON.parse(sessionStorage.getItem("userData")) || {};
  // const modalRef = React.useRef(null);
  const [modalId, setModalId] = React.useState("");

  const callComp = (detailType) => {
    switch (detailType) {
      case "hotel":
        setModalId("hotel-booking-details-modal");
        return (
          <HotelDetail
            hotel={modalData}
            dispatch={dispatch}
            Authorization={Authorization}
            forDelete={{ setDeleting, setModalData, setShow }}
          />
        );
        break;
      case "transfer":
        setModalId("transfer");
        return (
          <TransferDetail ConfirmationNo={modalData} checkRef={checkRef} />
        );
        break;
      case "carrent":
        setModalId("car-booking-details-modal");
        return <CarrentDetail carRental={modalData} />;
        break;
      case "flight":
        setModalId("flight-booking-details-modal");
        return <FlightDetail flightData={modalData} />;
        break;
    }
  };

  const deleteData = (val) => {
    if (val !== "") {
      return (
        <CancelBooking
          id={modalData}
          type={val}
          setShow={setShow}
          setDeleting={setDeleting}
          change={change}
          setChange={setChange}
          setTripType={setTripType}
        />
      );
    }
  };

  // const deleteFunc=(val)=>{
  //   switch(val):{
  //     case "hotel":
  //   }
  // }

  const callMemo = useMemo(() => callComp(detailType), [detailType]);

  return (
    <>
      <div
        className={`modal my-auto ${show ? "d-flex" : "d-none"}`}
        id={modalId}
      >
        <div
          className={`${
            // detailType === "transfer"
            "container-fluid mt-5"
            // : "modal-dialog modal-lg"
          }`}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div
                  action=""
                  className={
                    deleting !== ""
                      ? "cmn-form transfer-detail-main-wrapper cancelle-booking"
                      : "cmn-form transfer-detail-main-wrapper"
                  }
                >
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setShow(false);
                      // extraData(false);
                    }}
                  ></button>
                  {/* {callComp(detailType)} */}
                  {callMemo}
                  {deleting !== "" && deleteData(deleting)}
                  {/* {detailType === "hotel" && <HotelDetail />} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailModal;
